import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { AbiProfileRequestModel, SelfFilerCodeRequestModel, SelfFilerModel } from '../models/companies';

@Injectable({
  providedIn: 'root',
})
export class SelfFilerRepository {
  constructor(private apiService: ApiService) {}

  public getSelfFiler(companyId: number, isUsed: boolean = false, isShowLoader: boolean = true): Observable<SelfFilerModel> {
    return this.apiService.get<SelfFilerModel>(`${environment.url.companies}${companyId}/self-filer`, null, { isUsed, isShowLoader });
  }

  public sendFilerCodeRequest(companyId: number, body: SelfFilerCodeRequestModel): Observable<never> {
    return this.apiService.post(`${environment.url.companies}${companyId}/self-filer/filer-code-request`, body);
  }

  public sendAbiProfileRequest(companyId: number, body: AbiProfileRequestModel): Observable<never> {
    return this.apiService.post(`${environment.url.companies}${companyId}/self-filer/abi-profile-request`, body);
  }

  public sendAchMethodRequest(companyId: number): Observable<never> {
    return this.apiService.post(`${environment.url.companies}${companyId}/self-filer/ach-method-request`);
  }

  public setSelfFiler(filerCode: string, companyId: number): Observable<never> {
    return this.apiService.post(`${environment.url.companies}${companyId}/self-filer/filer-code`, {
      filerCode,
    });
  }

  public setAbiClient(abiRepresentativeId: number, companyId: number): Observable<never> {
    return this.apiService.post(`${environment.url.companies}${companyId}/self-filer/abi-profile`, { abiRepresentativeId });
  }

  public deleteAbiClient(companyId: number): Observable<never> {
    return this.apiService.delete(`${environment.url.companies}${companyId}/self-filer/abi-profile`);
  }

  public setPaymentUnitNumber(paymentUnitNumber: string, companyId: number): Observable<never> {
    return this.apiService.post(`${environment.url.companies}${companyId}/self-filer/ach-method`, { paymentUnitNumber });
  }

  public deletePaymentUnitNumber(companyId: number): Observable<never> {
    return this.apiService.delete(`${environment.url.companies}${companyId}/self-filer/ach-method`);
  }

  public updateAdditionalPorts(ports: string[], companyId: number): Observable<never> {
    return this.apiService.put(`${environment.url.companies}${companyId}/self-filer/allowed-ports`, ports);
  }

  public setMainPort(portCode: string, companyId: number): Observable<never> {
    return this.apiService.put(`${environment.url.companies}${companyId}/self-filer/home-port`, JSON.stringify(portCode));
  }

  public sendAbiTransmitterUpdateApproved(companyId: number, value: boolean): Observable<never> {
    return this.apiService.post(`${environment.url.companies}${companyId}/self-filer/abi-transmitter-update-approved`);
  }
}
